import {useWindowSize} from './useWindowSize';

export function UseIsSmallScreen() {
  const windowSize = useWindowSize();
  return windowSize.width < 600;
}